import { useState } from 'react';
import { get_form_url_result } from '@/mocks/form-url';

export default function NewsletterForm() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('website_alt') as string || '').trim();
    if (honeypot) {
      setStatus('success');
      setMessage('感谢订阅！');
      return;
    }

    setStatus('loading');
    try {
      const res = await fetch(get_form_url_result.submitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('感谢订阅！我们会定期为您推送精选内容。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '订阅失败，请稍后再试';
        setStatus('error');
        setMessage(serverMsg);
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请稍后再试。');
    }
  };

  return (
    <form onSubmit={handleSubmit} data-readdy-form className="flex flex-col sm:flex-row gap-3 w-full max-w-md">
      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="honeypot-field"
      />
      <input
        type="email"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        placeholder="输入你的邮箱地址"
        required
        className="flex-1 px-4 py-3 text-sm bg-background-50 border border-background-200 rounded-full outline-none focus:border-primary-400 transition-colors"
      />
      <button
        type="submit"
        disabled={status === 'loading'}
        className="px-6 py-3 text-sm font-medium bg-primary-500 text-background-50 rounded-full hover:bg-primary-600 transition-colors disabled:opacity-60 whitespace-nowrap cursor-pointer"
      >
        {status === 'loading' ? '订阅中...' : '订阅'}
      </button>
      {status !== 'idle' && (
        <div className={`sm:col-span-2 text-sm ${status === 'success' ? 'text-secondary-700' : 'text-primary-600'}`}>
          {message}
        </div>
      )}
    </form>
  );
}